import { writable } from 'svelte/store';

export const video_is_playing = writable(false);